import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import CommunitiesControlsFiltersAuditType from './CommunitiesControlsFiltersAuditType';
import CommunitiesControlsFiltersCompany from './CommunitiesControlsFiltersCompany';
import CommunitiesControlsFiltersCompanyStatus from './CommunitiesControlsFiltersCompanyStatus';

const Container = styled.div`
  display: flex;
  gap: 5px;
`;

const CommunitiesControlsFilters = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const isAdminUser = Boolean(currentUser?.isSuperuser || currentUser?.isStaff);

  return (
    <Container>
      <CommunitiesControlsFiltersCompany />
      <CommunitiesControlsFiltersCompanyStatus />
      {isAdminUser && <CommunitiesControlsFiltersAuditType />}
    </Container>
  );
};

export default CommunitiesControlsFilters;
